function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'black': 'rgb(0, 0, 0)','black-metallic': 'rgb(44, 44, 43)','black-black': 'rgb(0, 0, 0)','white': 'rgb(245, 245, 245)','snow-white': 'rgb(255, 250, 250)','orange': 'rgb(255, 84, 16)','navy': 'rgb(48, 54, 77)','midnight-navy': 'rgb(31, 36, 55)','light-pink': 'rgb(226, 216, 211)','olive': 'rgb(67, 64, 48)','light-olive': 'rgb(162, 141, 96)','forrest': 'rgb(64, 56, 47)','forrest-dark-grey': 'rgb(77, 67, 59)','dark-green': 'rgb(60, 55, 44)','sand': 'rgb(228, 214, 199)','beige': 'rgb(198, 174, 143)','dark-beige': 'rgb(103, 83, 68)','chocolate': 'rgb(60, 47, 46)','crisp-champagne': 'rgb(187, 151, 127)','bright-red': 'rgb(214, 0, 20)','chestnut': 'rgb(117, 70, 40)','blue': 'rgb(48, 54, 77)','ocean-blue': 'rgb(0, 181, 241)','ice-blue': 'rgb(171, 205, 221)','sky-blue': 'rgb(171, 205, 221)','light-blue': 'rgb(171, 205, 221)','royal-yellow': 'rgb(250, 218, 94)','grey': 'rgb(189, 189, 193)','titanium': 'rgb(199, 198, 192)','brown-leather': 'rgb(60, 47, 46)','black-leather': 'rgb(0, 0, 0)','orange-leather': 'rgb(255, 84, 16)','light-blue-leather': 'rgb(171, 205, 221)','blue-nubuck-leather': 'rgb(48, 54, 77)','olive-nubuck-leather': 'rgb(67, 64, 48)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
